/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Risk_Personal_Data_HintInputs */



/**
* | output |
* | --- |
* | "Processes personal data. Relevant to your records of processing activities." |
*
* @param {Integrations_Risk_Personal_Data_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_risk_personal_data_hint = /** @type {((inputs?: Integrations_Risk_Personal_Data_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Risk_Personal_Data_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitet personenbezogene Daten. Relevant für Ihr Verarbeitungsverzeichnis.")
	return /** @type {LocalizedString} */ ("Processes personal data. Relevant to your records of processing activities.")
});